import React from 'react';

const sgContainer  = (props) => {
    return(
        <div className = "container">
            {props.children}
        </div>
    )
}
export default sgContainer;